import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/css/tailwind.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/pliny/search/algolia.css");
